/**
 * Copy shown before a normal social sign-in on /login (requestSignUp: true).
 * Sigma matches on the provider account id. An unknown provider account
 * creates a new Sigma user (Better Auth's implicit auto-link can still
 * attach it to an existing account on a verified matching email, which is
 * the less surprising outcome and not worth a longer sentence).
 */
export const SOCIAL_SIGN_IN_NEW_ACCOUNT_NOTICE =
	"If this provider account isn't linked yet, Sigma will create a new account.";

export const NEW_SIGMA_ACCOUNT_CREATED = "New Sigma account created";
